import script from "./cau-hinh-hien-thi-dich-vu.vue?vue&type=script&setup=true&lang=js"
export * from "./cau-hinh-hien-thi-dich-vu.vue?vue&type=script&setup=true&lang=js"

import "./cau-hinh-hien-thi-dich-vu.vue?vue&type=style&index=0&id=f2b1f764&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b1f764"]])

export default __exports__